import {
  Props as FontAwesomeIconProps,
  FontAwesomeIcon as Icon,
} from '@fortawesome/react-native-fontawesome'
import * as React from 'react'

export function FontAwesomeIcon(props: FontAwesomeIconProps) {
  return <Icon {...props} />
}

export { type FontAwesomeIconProps }

export type * from '@fortawesome/fontawesome-common-types'
